import { ShieldCheck, Sparkles, UserCheck, SlidersHorizontal, BadgeCheck, CalendarClock } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const REASONS = [
  { icon: ShieldCheck, slug: "zuverlaessigkeit", title: "Zuverlässigkeit", desc: "Vereinbarte Leistungen werden zuverlässig und sorgfältig ausgeführt." },
  { icon: Sparkles, slug: "gruendlichkeit", title: "Gründlichkeit", desc: "Sauberkeit bis ins Detail." },
  { icon: UserCheck, slug: "ansprechpartner", title: "Persönlicher Ansprechpartner", desc: "Direkte Kommunikation statt unnötiger Umwege." },
  { icon: SlidersHorizontal, slug: "individuell", title: "Individuelle Lösungen", desc: "Reinigungskonzepte passend zu Objekt und Bedarf." },
  { icon: BadgeCheck, slug: "professionell", title: "Professionelles Auftreten", desc: "Diskrete und professionelle Durchführung im laufenden Geschäftsbetrieb." },
  { icon: CalendarClock, slug: "flexibel", title: "Flexible Planung", desc: "Reinigungszeiten nach Absprache und passend zum betrieblichen Ablauf." },
];

export const Trust = () => (
  <section id="ueber-uns" className="relative bg-navy py-16 md:py-24 overflow-hidden" data-testid="trust-section">
    <div className="noise-overlay" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Chapter number="03" label="Warum EMT-Reinigung" dark />
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white max-w-2xl">
          Darauf können Sie sich verlassen
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REASONS.map((r, i) => (
          <Reveal key={r.slug} delay={Math.min(i * 0.06, 0.3)}>
            <article
              className="h-full rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-7 transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 hover:border-ice/30"
              data-testid={`trust-card-${r.slug}`}
            >
              <div className="w-11 h-11 rounded-full bg-ice/10 flex items-center justify-center mb-5">
                <r.icon className="w-5 h-5 text-ice" strokeWidth={1.8} />
              </div>
              <h3 className="font-heading text-xl font-medium text-white">{r.title}</h3>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">{r.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
